import ContentPage from './ContentPage';

export default ContentPage;
